import OAButton from './OAButton.vue'

const data = {
  install: function (Vue) {
    Vue.component('OAButton', OAButton)
  }
}
export default data



// WEBPACK FOOTER //
// ./src/components/OAButton/index.js